<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title font-weight-normal">
        {{ $t("Summary & Performance Report") }}
      </div>
      <small><em>{{ $t("* As Per show Date") }}</em></small>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("from") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("to") }}</label
                >
              </div>
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-4 align-self-center mb-3"
            v-if="isCinemaAkhil"
          >
            <div class="dropdown-curve-container">
              <label :class="selectedCategoryName ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Category", 1) }}</label
              >
              <multiselect
                v-model="selectedScheduleCategory"
                track-by="ss_category_id"
                label="ss_category_name"
                @select="onSelectScheduleCategory($event, $event)"
                @remove="onRemoveSelectScheduleCategory($event, $event)"
                :options="scheduleCategoryList"
                :multiple="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getSummaryPerformanceData()"
            >
              {{ $t("FETCH") }}
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title font-weight-normal">Summary</div>

        <div
          v-if="
            Object.keys(summaryData).length ||
              Object.keys(boxOfficeData).length ||
              Object.keys(concessionData).length
          "
          class="mr-3 align-self-center d-flex justify-content-end align-items-center"
        >
          <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
          <a
            target="_blank"
            @click="getSummaryReport('Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>

      <div class="mx-2 row">
        <div class="col-4 py-2" style="border: solid black 1px; border-right: transparent; border-bottom: transparent;" >
          <div
            class="font-weight-bold border border-1 border-dark mb-2 text-center"
           
          >
            Summary
          </div>

          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                {{
                  isPlay || isPlatinium
                    ? "Total Admits (Incl. Comp.):"
                    : "Total Admits:"
                }}
              </td>

              <td class="text-right small px-1">
                {{ summaryData.total_admits ? summaryData.total_admits : 0 }}
              </td>
            </tr>

            <tr v-if="isPlay || isPlatinium">
              <td class="text-left small font-weight-bold px-1">
                Total Comp. Admits :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.complimentary_admits_payment_mode_wise
                    ? summaryData.complimentary_admits_payment_mode_wise
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Transactions :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_transactions
                    ? summaryData.total_transactions
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Seats In Cinema :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_seats_in_cinema
                    ? summaryData.total_seats_in_cinema
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Screen :
              </td>

              <td class="text-right small px-1">
                {{ summaryData.total_screen ? summaryData.total_screen : 0 }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total No of Shows :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_no_of_shows
                    ? summaryData.total_no_of_shows
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Avg. of Shows :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.avg_shows ? currFormat(summaryData.avg_shows) : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Capacity Available :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_capacity_available
                    ? summaryData.total_capacity_available
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Revenue :
              </td>

              <td class="text-right small px-1">
                {{
                  summaryData.total_capacity_available
                    ? currFormat(summaryData.total_revenue_conv)
                    : 0
                }}
              </td>
            </tr>

            <tr
              v-if="
                Object.keys(summaryData).length &&
                  Object.keys(summaryData['IMAX3D']).length > 0
              "
            >
              <td class="text-left small font-weight-bold px-1">Imax 3D</td>
              <td class="text-right small px-1">
                {{ summaryData["IMAX3D"].qty }}
              </td>
            </tr>
            <tr
              v-if="
                Object.keys(summaryData).length &&
                  Object.keys(summaryData['3DOnlyQty']).length > 0
              "
            >
              <td class="text-left small font-weight-bold px-1">3D Only:</td>
              <td class="text-right small px-1">
                {{ summaryData["3DOnlyQty"].qty }}
              </td>
            </tr>
            <template
              v-if="
                Object.keys(boxOfficeData).length &&
                  boxOfficeData.final_addons_array.length > 0
              "
            >
              <tr>
                <td class="text-center small font-weight-bold px-1" colspan="2">
                  {{ $t("additionalChanges") }}
                </td>
                <!-- <td class="p-1">Amount</td> -->
              </tr>
              <tr
                v-for="(addOnitem,
                addOnsitemIndex) in boxOfficeData.final_addons_array"
                :key="addOnsitemIndex"
              >
                <td class="text-left small font-weight-bold px-1">
                  {{ addOnitem.addons_name }}
                </td>
                <td class="text-right small px-1">
                  {{ addOnitem.quantity }}
                </td>
              </tr>
            </template>
          </table>
        </div>

        <div class="col-4 py-2" style="border: solid black 1px; border-bottom: transparent">
          <div
            class="font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Box Office
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Box Office Rev.(BOR) :
              </td>

              <td class="text-right small px-1">
                {{
                  boxOfficeData.bo_revenue_conv
                    ? currFormat(boxOfficeData.bo_revenue_conv)
                    : 0
                }}
              </td>
            </tr>

            <template
              v-if="
                boxOfficeData.transactionTaxData &&
                  boxOfficeData.transactionTaxData.length
              "
            >
              <tr
                v-for="(taxData,
                taxDataIndex) in boxOfficeData.transactionTaxData"
                :key="taxDataIndex"
              >
                <td class="text-left small font-weight-bold px-1">
                  {{ taxData.charge_type_name }} :
                </td>
                <td class="text-right small px-1">
                  {{ currFormat(taxData.tax_value_conv) }}
                </td>
              </tr>
            </template>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Service Charge :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.service_charge_conv) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Add. Chgs (Addl. Tax / FDF) :
              </td>
              <td class="text-right small px-1">0</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Net BOR :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.net_bor_conv
                    ? currFormat(boxOfficeData.net_bor_conv)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.total_transactions
                    ? boxOfficeData.total_transactions
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">ATP :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.atp_conv
                    ? currFormat(boxOfficeData.atp_conv)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Net ATP :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.net_atp_conv
                    ? currFormat(boxOfficeData.net_atp_conv)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Occupancy :</td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.occupancy
                    ? currFormat(boxOfficeData.occupancy)
                    : 0
                }}
              </td>
            </tr>
            <tr
              v-if="
                Object.keys(boxOfficeData).length &&
                  Object.keys(boxOfficeData['IMAX3D']).length
              "
            >
              <td class="text-left small font-weight-bold px-1">IMAX 3D</td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData["IMAX3D"].gross_amount) || "0" }}
              </td>
            </tr>
            <tr
              v-if="
                Object.keys(boxOfficeData).length &&
                  Object.keys(boxOfficeData['3DOnlyQty']).length
              "
            >
              <td class="text-left small font-weight-bold px-1">3D Only:</td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData["3DOnlyQty"].gross_amount) || "0" }}
              </td>
            </tr>
            <template
              v-if="
                Object.keys(boxOfficeData).length &&
                  boxOfficeData.final_addons_array.length > 0
              "
            >
              <tr>
                <td class="text-center small font-weight-bold px-1" colspan="2">
                  {{ $t("additionalChanges") }}
                </td>
                <!-- <td class="p-1">Amount</td> -->
              </tr>
              <tr
                v-for="(addOnitem,
                addOnsitemIndex) in boxOfficeData.final_addons_array"
                :key="addOnsitemIndex"
              >
                <td class="text-left small font-weight-bold px-1">
                  {{ addOnitem.addons_name }}
                </td>
                <td class="text-right small px-1">
                  {{ currFormat(addOnitem.final_price) }}
                </td>
              </tr>
            </template>
          </table>
        </div>

        <div class="col-4 py-2" style="border: solid black 1px; border-left: transparent; border-bottom: transparent">
          <div
            class="font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Concessions
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross Revenue :
              </td>

              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue
                    ? currFormat(concessionData.gross_revenue)
                    : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">TAX :</td>
              <td class="text-right small px-1">
                {{ concessionData.vat ? currFormat(concessionData.vat) : 0 }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Conc. Net Revenue :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.concession_net_revenue
                    ? currFormat(concessionData.concession_net_revenue)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Spend Per Head :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue && summaryData.total_admits
                    ? currFormat(
                        concessionData.gross_revenue / summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Cost of Goods Sold :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.cost_goods_sold
                    ? currFormat(concessionData.cost_goods_sold)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Food Cost :</td>
              <td class="text-right px-1">
                {{
                  concessionData.food_cost
                    ? currFormat(concessionData.food_cost)
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Transactions :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.transactions ? concessionData.transactions : 0
                }}
              </td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">
                Admission Strike Rate :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue && summaryData.total_transactions
                    ? currFormat(
                        concessionData.gross_revenue /
                          summaryData.total_transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small bold-text font-weight-bold px-1">
                Avg. Value Per Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.gross_revenue && concessionData.transactions
                    ? currFormat(
                        concessionData.gross_revenue /
                          concessionData.transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small bold-text font-weight-bold px-1">
               {{ isPlay || isPlatinium ? 'Qty of Item Sold (Inc. Comp.) :' : 'Qty of Item Sold :'}}
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.qty_items_sold
                    ? concessionData.qty_items_sold
                    : 0
                }}
              </td>
            </tr>
            <tr v-if="isPlay || isPlatinium">
              <td class="text-left small font-weight-bold px-1">
               Qty of Item Sold Comp. :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.complimentary_admits_for_fnb
                    ? concessionData.complimentary_admits_for_fnb
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td
                class="text-left small bold-text font-weight-bold px-1"
                style="white-space: nowrap"
              >
                Avg. Cost Per Admits :
              </td>
              <td class="text-right small px-1" style="white-space: nowrap">
                {{
                  concessionData.cost_goods_sold && summaryData.total_admits
                    ? currFormat(
                        concessionData.cost_goods_sold /
                          summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
          </table>
        </div>

        <div class="col-4 py-2" style="border: solid black 1px; border-right: transparent;">
          <div
            class="font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Performance Indicators
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Items Per Admit :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.qty_items_sold && summaryData.total_admits
                    ? currFormat(
                        concessionData.qty_items_sold / summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Items Per Transaction :
              </td>
              <td class="text-right small px-1">
                {{
                  concessionData.qty_items_sold && concessionData.transactions
                    ? currFormat(
                        concessionData.qty_items_sold /
                          concessionData.transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Transaction Strike Rate :
              </td>
              <td class="text-right px-1">
                {{
                  concessionData.gross_revenue &&
                  boxOfficeData.total_transactions
                    ? currFormat(
                        concessionData.gross_revenue /
                          boxOfficeData.total_transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross Box Rev. Per Seat :
              </td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.bo_revenue_conv &&
                  summaryData.total_capacity_available
                    ? currFormat(
                        boxOfficeData.bo_revenue_conv /
                          summaryData.total_capacity_available
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Net Box Rev. Per Seat :
              </td>
              <td class="text-right small px-1">
                {{
                  boxOfficeData.net_bor && summaryData.total_capacity_available
                    ? currFormat(
                        boxOfficeData.net_bor /
                          summaryData.total_capacity_available
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Total Revenue Per Seat :
              </td>
              <td class="text-right px-1">
                {{
                  summaryData.total_revenue &&
                  summaryData.total_capacity_available
                    ? currFormat(
                        summaryData.total_revenue /
                          summaryData.total_capacity_available
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Avg. Sale Per Trans. :
              </td>
              <td class="text-right small px-1">
                {{
                  summaryData.total_revenue && summaryData.total_transactions
                    ? currFormat(
                        summaryData.total_revenue /
                          summaryData.total_transactions
                      )
                    : 0
                }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Avg. Sale Per Patron :
              </td>
              <td class="text-right px-1">
                {{
                  summaryData.total_revenue_conv && summaryData.total_admits
                    ? currFormat(
                        summaryData.total_revenue_conv /
                          summaryData.total_admits
                      )
                    : 0
                }}
              </td>
            </tr>
          </table>
        </div>

        <div class="col-4 py-2" style="border: solid black 1px; border-right: transparent;">
          <div
            class="font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Misc. & Sales Channel Performance
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Miscellaneous Income :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(summaryData.addons_charges) }}
              </td>
            </tr>
          </table>

          <table
            class="swc-report-table mt-2"
            border="1"
            v-if="SalesChannelPerformance.length && !isEpix"
          >
            <thead class=" font-weight-bold">
              <th>Channel</th>
              <th>Tickets</th>
              <th>Booking Fees</th>
              <th>Sales</th>
            </thead>
            <tr
              v-for="(salesChannelObj,
              salesChannelObjIndex) in SalesChannelPerformance"
              :key="salesChannelObjIndex"
            >
              <td class="text-left">{{ salesChannelObj.bs_source }}</td>
              <td class="text-right">{{ salesChannelObj.sales_count }}</td>
              <td class="text-right">
                {{ currFormat(salesChannelObj.internet_handling_fee) }}
              </td>
              <td class="text-right">
                {{ currFormat(salesChannelObj.total_sales) }}
              </td>
            </tr>
          </table>

          <table class="swc-report-table border border-0" v-else>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross BO Revenue(Before Offer) :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.bo_revenue_before_offer) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Promotion/MKTG Exp Rev :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.offer_price) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                BOR(after Disc.) :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(boxOfficeData.bo_revenue) }}
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                Gross FnB Revenue :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(concessionData.gross_revenue) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">FnB Disc :</td>
              <td class="text-right small px-1">
                {{ currFormat(concessionData.total_offer_price) }}
              </td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">
                FnB Revenue(after Disc.) :
              </td>
              <td class="text-right small px-1">
                {{ currFormat(concessionData.gross_revenue) }}
              </td>
            </tr>
          </table>
        </div>

        <div class="col-4 py-2" style="border: solid black 1px; ">
          <div
            class="font-weight-bold border border-1 border-dark mb-2 text-center"
          >
            Concessions Profit Performance
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold  px-1"
                >Profit at Standard Cost :</td
              >

              <td class="text-right small px-1">{{
                concessionData.concession_net_revenue &&
                concessionData.cost_goods_sold
                  ? currFormat(
                      concessionData.concession_net_revenue -
                        concessionData.cost_goods_sold
                    )
                  : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold  px-1 "
                >Profit % :</td
              >
              <td class="text-right small  px-1">{{
                currFormat(
                  ((concessionData.concession_net_revenue -
                    concessionData.cost_goods_sold) /
                    concessionData.concession_net_revenue) *
                    100
                )
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold  px-1"
                >Profit per Item :</td
              >
              <td class="text-right small px-1">{{
                currFormat(
                  (concessionData.concession_net_revenue -
                    concessionData.cost_goods_sold) /
                    concessionData.qty_items_sold
                )
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold  px-1"
                >Profit Per Admit :</td
              >
              <td class="text-right small px-1">{{
                currFormat(
                  (concessionData.concession_net_revenue -
                    concessionData.cost_goods_sold) /
                    summaryData.total_admits
                )
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold  px-1"
                >Profit Per Transaction :</td
              >
              <td class="text-right small px-1">{{
                currFormat(
                  (concessionData.concession_net_revenue -
                    concessionData.cost_goods_sold) /
                    concessionData.transactions
                )
              }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title font-weight-normal my-2">Performance</div>
        <div
          v-if="performanceRecords.length > 0"
          class="mr-3 align-self-center d-flex justify-content-end align-items-center"
        >
          <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
          <!-- s -->

          <a
            target="_blank"
            @click="getPerformanceReport('Y', 'N')"
            title="Download as Excel"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </a>
          <a
            target="_blank"
            @click="getPerformanceReport('N', 'Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>
      <div class="table-scroll">
        <table class="performance-report-table" border="1">
          <thead style="background-color: transparent;">
            <!-- <tr>
              <td colspan="2"></td>
              <td colspan="3">Audience</td>
              <td colspan="4">
                {{ $t("revenue") }}
              </td>
              <td colspan="2">ATP</td>
            </tr> -->
            <tr>
              <td>{{ $t("film") }}</td>
              <td class="maxWidht50">{{ $t("noof") }} {{ $t("shows") }}</td>
              <td>{{ $t("admits") }}</td>
              <td>{{ $t("capacity") }}</td>
              <td class="maxWidht50">{{ $t("occupancy") }} %</td>
              <td class="maxWidht50">BOR</td>
              <td class="maxWidht50">VAT</td>
              <td class="maxWidht50"v-if="!isPlatinium" >{{ secondaryTaxName }}</td>
              <td class="maxWidht50">Net BOR</td>
              <td class="maxWidht50">BOR ATP</td>
              <td class="maxWidht50">Net ATP</td>
            </tr>
          </thead>

          <tbody v-if="performanceRecords.length">
            <tr
              v-for="(performanceObj, performanceIndex) in performanceRecords"
              :key="performanceIndex"
            >
              <!-- <td class="text-left">{{ `${performanceObj.movieName}` }}</td> -->
               <td class="text-left">{{  `${performanceObj.movie_name} ${performanceObj.ss_category_name?`(${performanceObj.ss_category_name})`:``} ` }}</td>
              <td class="text-right">{{ performanceObj.total_shows }}</td>
              <td class="text-right">{{ performanceObj.admits }}</td>
              <td class="text-right">
                {{ performanceObj.available_capacity }}
              </td>
              <td class="text-right">
                {{
                  performanceObj.admits && performanceObj.available_capacity
                    ? currFormat(
                        ((performanceObj.admits /
                          performanceObj.available_capacity) *
                          10000) /
                          100
                      )
                    : "0.00"
                }}
              </td>
              <td class="text-right">{{ currFormat(performanceObj.bor) }}</td>
              <td class="text-right">{{ currFormat(performanceObj.vat) }}</td>
              <td class="text-right" v-if="!isPlatinium">{{
                currFormat(performanceObj.gcam)
              }}</td>
              <td class="text-right">
                {{ currFormat(performanceObj.net_bor) }}
              </td>
              <td class="text-right">
                {{
                  performanceObj.bor && performanceObj.admits
                    ? currFormat(performanceObj.bor / performanceObj.admits)
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  performanceObj.net_bor && performanceObj.admits
                    ? currFormat(performanceObj.net_bor / performanceObj.admits)
                    : 0
                }}
              </td>
            </tr>
            <tr class="font-weight-bold">
              <td class="text-lef">Grand Total</td>
              <td class="text-right">
                {{ performanceRecordsGrandTotal.total_shows }}
              </td>
              <td class="text-right">
                {{ performanceRecordsGrandTotal.admits }}
              </td>
              <td class="text-right">
                {{ performanceRecordsGrandTotal.available_capacity }}
              </td>
              <td class="text-right">
                {{
                  performanceRecordsGrandTotal.admits &&
                  performanceRecordsGrandTotal.available_capacity
                    ? currFormat(
                        ((performanceRecordsGrandTotal.admits /
                          performanceRecordsGrandTotal.available_capacity) *
                          10000) /
                          100
                      )
                    : 0
                }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.bor) }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.vat) }}
              </td>
              <td class="text-right" v-if="!isPlatinium">
                {{ currFormat(performanceRecordsGrandTotal.gcam) }}
              </td>
              <td class="text-right">
                {{ currFormat(performanceRecordsGrandTotal.net_bor) }}
              </td>
              <td class="text-right">
                {{
                  performanceRecordsGrandTotal.bor &&
                  performanceRecordsGrandTotal.admits
                    ? currFormat(
                        performanceRecordsGrandTotal.bor /
                          performanceRecordsGrandTotal.admits
                      )
                    : 0
                }}
              </td>
              <td class="text-right">
                {{
                  performanceRecordsGrandTotal.net_bor &&
                  performanceRecordsGrandTotal.admits
                    ? currFormat(
                        performanceRecordsGrandTotal.net_bor /
                          performanceRecordsGrandTotal.admits
                      )
                    : 0
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title font-weight-normal my-2">Concession Sales Analysis</div>
        <div
          v-if="performanceFnbRecords.length > 0"
          class="mr-3 align-self-center d-flex justify-content-end align-items-center"
        >
          <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
          <!-- s -->

          <a
            target="_blank"
            @click="getPerformanceFnBRecords('Y', 'N')"
            title="Download as Excel"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </a>
          <a
            target="_blank"
            @click="getPerformanceFnBRecords('N', 'Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>

      <div class="table-scroll">
        <template v-if="performanceFnbRecords.length > 0">
          <div v-for="(performanceFnbObj, performanceFnbIndex) in performanceFnbRecords" :key="'cat_table_' + performanceFnbIndex" class="mb-4">
            <table class="performance-report-table" border="1">
              <thead>
                <tr class="font-weight-bold">
                  <td style="width:250px; word-wrap: break-word; white-space: normal; overflow-wrap: break-word;">{{ performanceFnbObj.category_name }}</td>
                  <td>Qty Sold</td>
                  <td>Net Price</td>
                  <td>Std Profit</td>
                  <td>Std Profit%</td>
                  <td>Per 100 Qty</td>
                  <td>Per 100 Sale</td>
                  <td>Per 100 Profit</td>
                  <td>Net Sale</td>
                  <td>Sale Mix%</td>
                  <td>Net Profit</td>
                  <td>Profit Mix%</td>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                  <td class="text-left font-weight-bold" colspan="12">
                    {{ performanceFnbObj.category_name }}
                  </td>
                </tr> -->
                <tr
                  v-for="(performanceCategoryObj, performanceCategoryIndex) in performanceFnbObj.categoryItems"
                  :key="performanceCategoryIndex + '_category_data_' + performanceFnbIndex"
                  :class="performanceFnbObj.categoryItems.length - 1 == performanceCategoryIndex ? 'font-weight-bold' : ''"
                >
                  <td class="text-left" style="width:250px; word-wrap: break-word; white-space: normal; overflow-wrap: break-word;">{{ performanceCategoryObj.item_name }}</td>
                  <td class="text-right">{{ performanceCategoryObj.total_quantity }}</td>
                  <td class="text-right">{{ currFormat(performanceCategoryObj.total_amount / performanceCategoryObj.total_quantity) }}</td>
                  <td class="text-right">{{ currFormat(performanceCategoryObj.std_profit) }}</td>
                  <td class="text-right">
                    {{
                      currFormat(
                        (performanceCategoryObj.std_profit /
                          (performanceCategoryObj.total_amount / performanceCategoryObj.total_quantity)) *
                          100
                      )
                    }}
                  </td>
                  <td class="text-right">{{ currFormat((performanceCategoryObj.total_quantity * 100) / summaryData.total_admits) }}</td>
                  <td class="text-right">
                    {{
                      currFormat(
                        ((performanceCategoryObj.total_amount / performanceCategoryObj.total_quantity) *
                          (performanceCategoryObj.total_quantity * 100)) /
                          summaryData.total_admits
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        (performanceCategoryObj.std_profit * (performanceCategoryObj.total_quantity * 100)) /
                          summaryData.total_admits
                      )
                    }}
                  </td>
                  <td class="text-right">{{ currFormat(performanceCategoryObj.total_amount) }}</td>
                  <td class="text-right">{{ currFormat(performanceCategoryObj.sale_mix) }}</td>
                  <td class="text-right">{{ currFormat(performanceCategoryObj.net_profit_new) }}</td>
                  <td class="text-right">{{ currFormat(performanceCategoryObj.profit_mix) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

           <div style="font-size:18px;font-weight:bold;margin:20px 0 5px 0;text-align:center; margin-top: 45px;">
                         Grand Total

            </div>

          <table class="performance-report-table" border="1">
            <thead>
              <tr class="font-weight-bold">
                <!-- <td :style="`width: ${maxItemNameColWidth}px; max-width: ${maxItemNameColWidth}px; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;`"></td> -->
                <td>Qty Sold</td>
                <td>Net Price</td>
                <td>Std Profit</td>
                <td>Std Profit%</td>
                <td>Per 100 Qty</td>
                <td>Per 100 Sale</td>
                <td>Per 100 Profit</td>
                <td>Net Sale</td>
                <td>Sale Mix%</td>
                <td>Net Profit</td>
                <td>Profit Mix%</td>
              </tr>
            </thead>
            <tbody>
              <tr class="font-weight-bold">
                <!-- <td class="text-left" :style="`width: ${maxItemNameColWidth}px; max-width: ${maxItemNameColWidth}px; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;`">Grand Total</td> -->
                <td class="text-right">{{ performanceFnbRecordsGrandTotal.total_quantity }}</td>
                <td class="text-right">
                  {{
                    currFormat(
                      performanceFnbRecordsGrandTotal.total_amount /
                        performanceFnbRecordsGrandTotal.total_quantity
                    )
                  }}
                </td>
                <td class="text-right">{{ currFormat(performanceFnbRecordsGrandTotal.std_profit) }}</td>
                <td class="text-right">
                  {{
                    currFormat(
                      (performanceFnbRecordsGrandTotal.std_profit /
                        (performanceFnbRecordsGrandTotal.total_amount /
                          performanceFnbRecordsGrandTotal.total_quantity)) *
                        100
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat((performanceFnbRecordsGrandTotal.total_quantity * 100) / summaryData.total_admits)
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      ((performanceFnbRecordsGrandTotal.total_amount /
                        performanceFnbRecordsGrandTotal.total_quantity) *
                        (performanceFnbRecordsGrandTotal.total_quantity * 100)) /
                        summaryData.total_admits
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      (performanceFnbRecordsGrandTotal.std_profit *
                        (performanceFnbRecordsGrandTotal.total_quantity * 100)) /
                        summaryData.total_admits
                    )
                  }}
                </td>
                <td class="text-right">{{ currFormat(performanceFnbRecordsGrandTotal.total_amount) }}</td>
                <td class="text-right">{{ currFormat(performanceFnbRecordsGrandTotal.sale_mix) }}</td>
                <td class="text-right">{{ currFormat(performanceFnbRecordsGrandTotal.net_profit_new) }}</td>
                <td class="text-right">{{ currFormat(performanceFnbRecordsGrandTotal.profit_mix) }}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <table class="performance-report-table" border="1">
            <tbody>
              <tr>
                <td colspan="15"><NoRecords /></td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import ReportsServiceV2 from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        scheduleCategoryList: [],
        selectedScheduleCategoryId: null,
        selectedCategoryName: "",
        selectedScheduleCategory: {},
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        performanceRecords: [],
        performanceRecordsGrandTotal: {},
        summaryData: {},
        boxOfficeData: {},
        concessionData: {},
        performanceMovieRecords: [],
        performanceFnbRecords: [],
        performanceFnbRecordsTotal: {},
        performanceFnbRecordsGrandTotal: {},
        patronsTotal: {
          qtyTotal: 0,
          salesTotal: 0,
          profitTotal: 0,
        },
        excelFilePath: "",
        performancePdf: "",
        grandTotal: {},
        SalesChannelPerformance: [],
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      this.getShowScheduleCategories();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
    },
    mounted() {
      console.log("isPlatinium:", this.isPlatinium);
    },
    computed: {
      getPerPatronsTotal() {
        this.performanceFnbRecords.map((x) => {
          x.FoodCategory.map((y) => {
            this.patronsTotal["qtyTotal"] += +parseFloat(
              (y.fst_quantity * 100) / parseFloat(this.summaryData.total_admits)
            );
            this.patronsTotal["salesTotal"] += +parseFloat(
              (y.net_price_conv * (y.fst_quantity * 100)) /
                parseFloat(this.summaryData.total_admits)
            );
            this.patronsTotal["profitTotal"] += +parseFloat(
              (y.std_profit_conv * (y.fst_quantity * 100)) /
                parseFloat(this.summaryData.total_admits)
            );
          });
        });
        return this.patronsTotal;
      },
      getProfitStdCost() {
        let profitValue =
          this.concessionData.cost_goods_sold_conv &&
          this.concessionData.transactions
            ? this.concessionData.cost_goods_sold_conv *
              this.concessionData.transactions
            : 0;
        return profitValue;
      },
      secondaryTaxName() {
        return this.authorizeClient(CLIENT_NAMES_OBJ.mtax_clients)
          ? "M-Tax"
          : "GCAM";
      },
      isEpix() {
        return this.authorizeClient(CLIENT_NAMES_OBJ.EPIX);
      },
      isPlay() {
        return CLIENT_NAMES_OBJ.playcinema == this.CLIENT_SETUP_NAME;
      },
      isPlatinium() {
        return CLIENT_NAMES_OBJ.platinum == this.CLIENT_SETUP_NAME;
      },
      isCinemaAkhil() {
        return CLIENT_NAMES_OBJ.cinemaakhil == this.CLIENT_SETUP_NAME;
      },
    },
    methods: {
      onChangeDate(e, type) {
        if (type == "from") {
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
      moment,
      getShowScheduleCategories() {
        let payload = {
          tableName: "schedule_show_categories",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.scheduleCategoryList = data.Records.reverse();
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      onSelectScheduleCategory(event, category) {
        console.log("selectCategory=>");
        this.selectedCategoryName = category.ss_category_name;
        this.selectedScheduleCategoryId = category.ss_category_id;
        this.selectedScheduleCategory = category;
        // this.isChanged = true;
      },
      onRemoveSelectScheduleCategory() {
        console.log("selectCategory=>");
        this.selectedScheduleCategoryId = null;
        this.selectedCategoryName = "";
        this.selectedScheduleCategory = null;
      },
      concessionExcelDownload() {
        let temp_obj = this.performanceFnbRecords;
        let temp_arr = [];
        temp_obj.map((x) => {
          x.FoodCategory.map((y) => {
            let obj = { ...x, ...y, ...this.summaryData };
            temp_arr.push(obj);
          });
        });
        let data = [
          {
            sheet: "Concession Sales Report",
            columns: [
              {
                value: "item_name",
                label: "Item Name",
              },
              {
                value: "fst_quantity",
                label: "Qty Sold",
              },
              {
                value: (row) =>
                  row.net_price_conv
                    ? +parseFloat(row.net_price_conv).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : "-",
                label: "Net Price",
              },
              {
                value: (row) =>
                  row.std_profit_conv
                    ? +parseFloat(row.std_profit_conv).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : "-",
                label: "Std Profit",
              },

              {
                value: (row) =>
                  row.fst_quantity
                    ? +parseFloat(
                        (row.fst_quantity * 100) / row.total_admits
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Qty Per 100 Patrons",
              },
              {
                value: (row) =>
                  row.net_price_conv
                    ? +parseFloat(
                        row.net_price_conv *
                          ((row.fst_quantity * 100) / row.total_admits)
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Sales Per 100 Patrons",
              },
              {
                value: (row) =>
                  row.std_profit_conv
                    ? +parseFloat(
                        row.std_profit_conv *
                          ((row.fst_quantity * 100) / row.total_admits)
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Profit Per 100 Patrons",
              },
              {
                value: (row) =>
                  row.std_profit_conv && row.net_price_conv
                    ? +parseFloat(
                        (row.std_profit_conv / row.net_price_conv) * 100
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : 0,
                label: "Std Profit %",
              },
              {
                value: (row) =>
                  row.net_sales_conv
                    ? +parseFloat(row.net_sales_conv).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : "-",
                label: "Net Sale",
              },
              {
                value: (row) =>
                  row.net_sales_conv && row.total_net_sales_conv
                    ? +parseFloat(
                        (row.net_sales_conv / row.total_net_sales_conv) * 100
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : 0.0,
                label: "Sale Mix %",
              },
              {
                value: (row) =>
                  +parseFloat(row.net_profit_conv).toFixed(
                    this.MIN_FRACTION_DIGITS
                  ),
                label: "Net Profit",
              },
              {
                value: (row) =>
                  row.net_profit_conv && row.total_std_profit_conv
                    ? +parseFloat(
                        (+parseFloat(row.net_profit_conv) /
                          +parseFloat(row.total_std_profit_conv)) *
                          100
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : 0.0,
                label: "Profit Mix %",
              },

              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: temp_arr,
          },
        ];
        let settings = {
          fileName: `ConcessionReport${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getSummaryPerformanceData: async function() {
        Promise.all([
          this.getSummaryReport("N"),
          this.getSalesChannelWise(),
          this.getPerformanceReport("N", "N"),
          this.getPerformanceFnBRecords("N", "N"),
        ]).then(() => {});
      },
      getSalesChannelWise() {
        this.SalesChannelPerformance = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          ss_show_category_id: this.selectedScheduleCategoryId
            ? this.selectedScheduleCategoryId
            : null,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
        };
        ReportsService.GetSalesChannelPerformance(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.SalesChannelPerformance = [...data.Records];
            }
            this.$toasted.show(data.message);
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      getPerformanceReport(isExcel = "N", isPdf = "N") {
        this.performanceRecords = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          ss_show_category_id: this.selectedScheduleCategoryId,
          isExcel,
          isPdf,
        };
        ReportsService.GetPerformanceReportV5(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.performanceRecords = [...data.Records].sort(
                (a, b) => (b.admits || 0) - (a.admits || 0)
              );

              this.performanceRecordsGrandTotal = data.grandTotal;
              this.grandTotal = data.grandTotal;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                // console.log("Opening PDF:", data.pdfPath);
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      getSummaryReport(isPdf = "N") {
        this.summaryData = {};
        this.boxOfficeData = {};
        this.concessionData = {};
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }

        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          ss_show_category_id: this.selectedScheduleCategoryId,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isPdf,
        };
        ReportsService.GetSummaryV4(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records) {
              this.summaryData = { ...data.Records.summary };
              this.boxOfficeData = { ...data.Records.boxOffice };
              this.concessionData = { ...data.Records.concession };
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
            }
            this.$toasted.show(data.message);
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      getPerformanceFnBRecords(isExcel = "N", isPdf = "N") {
        this.performanceFnbRecords = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
        };
        if (isExcel == "Y") {
          payload["total_admits"] = this.summaryData.total_admits;
        }
        if (isPdf == "Y") {
          payload["total_admits"] = this.summaryData.total_admits;
        }
        ReportsService.GetConcessionPerformanceReportV5(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.performanceFnbRecords = [...data.Records];
              this.performanceFnbRecords.forEach((record) => {
                if (
                  record.categoryItems &&
                  Array.isArray(record.categoryItems)
                ) {
                  record.categoryItems.sort((a, b) => {
                    const quantityA = parseFloat(a.item_name) || 0;
                    const quantityB = parseFloat(b.item_name) || 0;
                    return quantityB - quantityA;
                  });
                }
              });
              this.performanceFnbRecordsGrandTotal = data.grandTotal;
              // this.grandTotal = data.grandTotal;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>

.maxWidht50 {
            width: 80px!important;
        }
.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

  .swc-report-table td {
    white-space: nowrap;
  }

  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }


.performance-report-table {
  width: 100%;
  min-width: 1200px;
  table-layout: fixed;
}

.performance-report-table thead tr {
  background: white !important;
}

.performance-report-table td {
  word-wrap: break-word; 
  overflow-wrap: break-word;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/summaryAndPerformanceReportAllClientV5.vue